<template>
	<div class="animated fadeIn">
		<div class="row">
			<div class="col-lg-12">
				<div class="card">
					<div class="card-header">Название урока</div>
					<div class="card-body">
						<vuetable ref="vuetable"
							:fields="columns"
							:api-mode="false"
							:data="tableData"
							:css="css.table"
							@vuetable:row-dblclicked="editRow"
							>
						</vuetable>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data () {
		return {
			columns: [
				{
					name: 'name',
					title: 'Название урока'
				}
			],
			tableData: [],
			css: {
				table: {
					tableClass: 'table table-striped table-bordered table-hovered',
					ascendingIcon: 'glyphicon glyphicon-chevron-up',
					descendingIcon: 'glyphicon glyphicon-chevron-down',
					handleIcon: 'glyphicon glyphicon-menu-hamburger'
				}
			}
		}
	},
	created () {
		this.getMailing()
	},
	methods: {
		getMailing () {
			this.$store.commit('CALL_API_ON')
			this.$http.get(this.$store.state.apiURL + '/v1/lessons', {}, {
			}).then(function (response) {
				this.tableData = response.body
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
				console.log('asdfasdf')
			})
		},
		editRow (rowData) {
			window.location = document.location.href + '/lesson/' + JSON.stringify(rowData.id)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/instruction/index.vue